export const TypographyH4 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h4
      className={`scroll-m-20 text-xl font-semibold tracking-tight ${
        className || ""
      }`}
      {...props}
    />
  );
};
